import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import enTranslation from './Localization/en.json'
import arTranslation from './Localization/ar.json'

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      ar: {
        translation: arTranslation
      }
    },
    interpolation: {
      escapeValue: false
    },
    fallbackLng: 'ar',
    lng: "ar",
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    supportedLngs: ['en', 'ar']
  })

export default i18n